import { useSnapshot } from "valtio"
import { routerStore } from "../../state/CommonState"
import ListCrm from "./list-crm"
import EditCrm from "./edit-crm"

export default function MainCrm(fn, mode) {
  const store = useSnapshot(routerStore)
  switch (store.managecrmCurrentViewNew) {
    case "list":
      return <ListCrm  fn={fn} />
    case "edit":
      return <EditCrm mode="edit" fn={fn} />
    case "new":
      return <EditCrm mode="new" fn={fn} />
    default:
      return <EditCrm mode="view" fn={fn} />
  }
}
